var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoDataLarge = function SvgNoDataLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "468px",
    height: "194px",
    viewBox: "0 0 468 194",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "desert_large")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salesforce-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration_large_desert",
    transform: "translate(-67.000000, -112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Empty-State-/-z-nested-/-Desert-/-Large"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desert"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 600,
    height: 400
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cloud2",
    transform: "translate(245.000000, 200.000000)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud2LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,17.5 L63,17.5 C62.2789714,12.0723971 64.081543,7.53186978 68.4077148,3.87841797 C73.3754883,-0.195556641 79.2734375,0.717773438 82.440918,2.12353516 C85.6083984,3.52929687 87.9606934,5.46069336 89.5913086,9.10524041 C90.2822266,10.6397351 90.7517904,11.9379883 91,13",
    id: "Cloud2Outline4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,20.5 C84.0558268,16.8461914 86.2227376,14.4572754 89.5007324,13.333252 C94.4177246,11.6472168 99.0800781,13.8925781 100.942383,16.1518555 C102.804687,18.4111328 103.39502,20.2260742 103.746582,22.1201172 C103.980957,23.3828125 104.06543,24.8427734 104,26.5 C108.141764,26.3313802 110.918945,27.1647135 112.331543,29 C114.040039,31.1936035 114.215332,33.817627 113.593018,35.75 C112.970703,37.682373 110.894531,40.5 107,40.5 L28,40.5",
    id: "Cloud2Outline3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 27.5,
    x2: 83.0004985,
    y2: 27.5,
    id: "Cloud2Outline2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 27.5,
    x2: 8,
    y2: 27.5,
    id: "Cloud2Outline1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud1",
    transform: "translate(135.000000, 152.000000)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud1LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,17.5 L63,17.5 C62.2789714,12.0723971 64.081543,7.53186978 68.4077148,3.87841797 C73.3754883,-0.195556641 79.2734375,0.717773438 82.440918,2.12353516 C85.6083984,3.52929687 87.9606934,5.46069336 89.5913086,9.10524041 C90.2822266,10.6397351 90.7517904,11.9379883 91,13",
    id: "Cloud1Outline4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,20.5 C84.0558268,16.8461914 86.2227376,14.4572754 89.5007324,13.333252 C94.4177246,11.6472168 99.0800781,13.8925781 100.942383,16.1518555 C102.804687,18.4111328 103.39502,20.2260742 103.746582,22.1201172 C103.980957,23.3828125 104.06543,24.8427734 104,26.5 C108.141764,26.3313802 110.918945,27.1647135 112.331543,29 C114.040039,31.1936035 114.215332,33.817627 113.593018,35.75 C112.970703,37.682373 110.894531,40.5 107,40.5 L28,40.5",
    id: "Cloud1Outline3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 27.5,
    x2: 83.0004985,
    y2: 27.5,
    id: "Cloud1Outline2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 27.5,
    x2: 8,
    y2: 27.5,
    id: "Cloud1Outline1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mountain",
    transform: "translate(69.000000, 256.000000)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "MountainLightBlue"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 36.5,
    x2: 464,
    y2: 36.5,
    id: "HorizontalLine4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 36.5,
    x2: 6,
    y2: 36.5,
    id: "HorizontalLine3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "MountainLine4",
    strokeLinejoin: "round",
    points: "234.5 36 279.5 0 313.5 26"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.5,
    y1: 1,
    x2: 279.5,
    y2: 35,
    id: "MountainLine3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5,11 C313.5,20.7437888 313.5,25.7437888 313.5,26 C313.5,25.7437888 313.5,20.7437888 313.5,11 Z",
    id: "MountainLine2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "MountainLine1",
    strokeLinejoin: "round",
    points: "303.5 17 313.5 9 347.5 36"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(113.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PlantLightBlue",
    transform: "translate(30.000000, 8.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5,60.5 L29.5,12 C29.5,5.372583 34.872583,0 41.5,0 C48.127417,0 53.5,5.372583 53.5,12 L53.5,40.5 L70.5,40.5 L70.5,27 C70.5,23.1340068 73.6340068,20 77.5,20 C81.3659932,20 84.5,23.1340068 84.5,27 L84.5,48.5 C84.5,51.8137085 81.8137085,54.5 78.5,54.5 L53.5,54.5 L53.5,118.5 L29.5,118.5 L29.5,74.5 L6.5,74.5 C3.1862915,74.5 0.5,71.8137085 0.5,68.5 L0.5,39 C0.5,35.1340068 3.63400675,32 7.5,32 C11.3659932,32 14.5,35.1340068 14.5,39 L14.5,60.5 L29.5,60.5 Z",
    id: "PlantLightBlueLine1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PlantHighlight",
    transform: "translate(59.000000, 7.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,11 C3.65332031,8.49145508 5.65181478,6.77364095 7.9954834,5.84655762 C11.5109863,4.45593262 15.2684326,4.95605469 17.8156738,6.2824707 C20.362915,7.60888672 22.3626709,9.64978027 23.2602539,11.81604 C23.8586426,13.2602132 23.8586426,11.7547201 23.2602539,7.29956055 L19.612793,3.56494141 L13.7923584,0.564331055 L8.765625,1.42663574 L4.67321777,3.19787598 C2.69893392,5.13902708 1.69559733,6.16722532 1.66320801,6.2824707 C1.61462402,6.45533878 0.856079102,9.49145508 0.813964844,9.66003418 C0.785888672,9.77242025 1.18123372,10.2190755 2,11 Z",
    id: "PlantHighlight1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PlantDarkBlue",
    stroke: "#8CD3F8",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 126.5,
    x2: 356,
    y2: 126.5,
    id: "HorizontalLine2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.5,
    y1: 126.5,
    x2: 372.013149,
    y2: 126.5,
    id: "HorizontalLine1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.5,
    y1: 20,
    x2: 107.5,
    y2: 28,
    id: "PlantDarkBlueLine10",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 30.6568542,
    x2: 118.656854,
    y2: 25,
    id: "PlantDarkBlueLine9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.5,
    y1: 32,
    x2: 37.5,
    y2: 40,
    id: "PlantDarkBlueLine8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 42.6568542,
    x2: 49.6568542,
    y2: 37,
    id: "PlantDarkBlueLine7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 42.6568542,
    x2: 30.6568542,
    y2: 37,
    id: "PlantDarkBlueLine6",
    strokeLinecap: "round",
    transform: "translate(27.828427, 39.828427) scale(-1, 1) translate(-27.828427, -39.828427) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.5,
    y1: 0,
    x2: 71.5,
    y2: 8,
    id: "PlantDarkBlueLine5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79,
    y1: 10.6568542,
    x2: 84.6568542,
    y2: 5,
    id: "PlantDarkBlueLine4",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 10.6568542,
    x2: 63.6568542,
    y2: 5,
    id: "PlantDarkBlueLine3",
    strokeLinecap: "round",
    transform: "translate(60.828427, 7.828427) scale(-1, 1) translate(-60.828427, -7.828427) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,68.5 L59.5,20 C59.5,13.372583 64.872583,8 71.5,8 C78.127417,8 83.5,13.372583 83.5,20 L83.5,48.5 L100.5,48.5 L100.5,35 C100.5,31.1340068 103.634007,28 107.5,28 C111.365993,28 114.5,31.1340068 114.5,35 L114.5,56.5 C114.5,59.8137085 111.813708,62.5 108.5,62.5 L83.5,62.5 L83.5,126.5 L59.5,126.5 L59.5,82.5 L36.5,82.5 C33.1862915,82.5 30.5,79.8137085 30.5,76.5 L30.5,47 C30.5,43.1340068 33.6340068,40 37.5,40 C41.3659932,40 44.5,43.1340068 44.5,47 L44.5,68.5 L59.5,68.5 Z",
    id: "PlantDarkBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,88.5 L92.5,88.5 L92.5,81 C92.5,77.1340068 95.6340068,74 99.5,74 C103.365993,74 106.5,77.1340068 106.5,81 L106.5,96.5 C106.5,99.8137085 103.813708,102.5 100.5,102.5 L77,102.5 L77,102.5",
    id: "PlantDarkBlueLine1",
    fill: "#C2E8FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant2",
    transform: "translate(429.000000, 242.000000)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plant2LightBlue"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 4,
    x2: 12.5,
    y2: 50,
    id: "Plant2LightBlueLine3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Plant2LightBlueLine3",
    strokeLinejoin: "round",
    points: "11 18.5 0.5 18.5 0.5 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Plant2LightBlueLine2",
    strokeLinejoin: "round",
    points: "14 25.5 24.5 25.5 24.5 8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Plant2LightBlueLine1",
    strokeLinejoin: "round",
    points: "2.5 31 2.5 38.5 11 38.5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Sun",
    transform: "translate(327.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SunLightBlue"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "SunBkgd",
    fill: "#C2E8FF",
    cx: 64,
    cy: 64,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,109 C88.8528137,109 109,88.8528137 109,64 C109,39.1471863 88.8528137,19 64,19 C39.1471863,19 19,39.1471863 19,64 C19,88.8528137 39.1471863,109 64,109 Z",
    id: "SunOutline3",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "135,1,1,18",
    transform: "translate(64.000000, 64.000000) rotate(230.000000) translate(-64.000000, -64.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,97 C82.2253967,97 97,82.2253967 97,64 C97,45.7746033 82.2253967,31 64,31 C45.7746033,31 31,45.7746033 31,64 C31,82.2253967 45.7746033,97 64,97 Z",
    id: "SunOutline2",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "107,10",
    transform: "translate(64.000000, 64.000000) rotate(150.000000) translate(-64.000000, -64.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "SunDarkBlue",
    transform: "translate(41.000000, 41.000000)",
    stroke: "#8CD3F8",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    id: "SunOutline",
    cx: 23,
    cy: 23,
    r: 23
  })))))))));
};
export default SvgNoDataLarge;